<sh-box id="header-widget-box-1" background="surface" padding="compact">
  <sh-box-section id="header-widget-box-section-2">

    <div style="display: flex; align-items: center;">

      <sh-icon id="header-widget-icon-3" (click)="openHelp(headerHelpTopic)" [icon]="headerIcon" size="s"
      style="cursor: help; margin-left: -2px; margin-right: 4px; padding-right: 3px;"></sh-icon>

      @if (!restrictedView && !isSiteSelection && isError) {
        <sh-tooltip id="header-widget-tooltip-4" target="errorbookmark" placement="left-up">
          {{ 'headerWidget.tooltip.bookmarksUnavailable' | transloco }}
        </sh-tooltip>
      }

      @if (!restrictedView && !isSiteSelection && (!selectedSystem?.SerialNumber || isLoading)) {
        <sh-tooltip id="header-widget-tooltip-5" target="errorbookmark" placement="left-up">
          {{ 'headerWidget.tooltip.availableUponSelection' | transloco }}
        </sh-tooltip>
      }

      <div style="display: flex; flex-direction: column; flex: 1 1 auto; min-width: 0;">
        <div style="display: flex; align-items: center; gap: 6px;">
          <sh-text id="header-widget-text-6" size="title-1" style="width: auto;">{{headerTitle}}</sh-text>
        </div>


        @if (!isSiteSelection && !isLoading && selectedSystem?.SerialNumber && selectedSystem.Functional_Location_ID !== null && !restrictedView) {
          <sh-text id="header-widget-text-7" (click)="openWithParams({ siteId: selectedSystem?.Functional_Location_ID})" style="width: auto; cursor: pointer;" size="body-1">
            @if (selectedSystem.Functional_Location_ID !== null) {
              <a>{{ selectedSystem?.LabName }}</a>
            }
          </sh-text>
        }

        @if (!isSiteSelection && !isLoading && selectedSystem?.SerialNumber && (selectedSystem.Functional_Location_ID === null || restrictedView)) {
          <sh-text id="header-widget-text-8" style="width: auto;"
            size="body-1">
            <span>{{ selectedSystem?.LabName }}</span>
          </sh-text>
        }

        @if (isSiteSelection || isLoading || !selectedSystem?.SerialNumber) {
          <sh-text id="header-widget-text-9" size="body-1">{{headerSubtitle}}</sh-text>
        }
      </div>


      <div style="display: flex; align-items: center; margin-left: auto; gap: 4px">
        @if (!restrictedView && !isSiteSelection) {
          <sh-icon toggle #systemicon button icon="information" id="systeminformation" size="s"
          (click)="openSystem()" [disabled]="!deviceInformation"></sh-icon>
          <span class="bookmark-wrapper">
            @if (!isBookmarked && !errorBookmark && !isLoading && selectedSystem?.SerialNumber) {
              <i
              class="pi pi-bookmark custom-book normal" (click)="updateBookmark($event)"></i>
            }
            @if (isBookmarked && !errorBookmark && !isLoading && selectedSystem?.SerialNumber) {
              <i
              class="pi pi-bookmark-fill custom-book normal" (click)="updateBookmark($event)"></i>
            }
            @if (errorBookmark || !selectedSystem?.SerialNumber || isLoading) {
              <i id="errorbookmark"
              class="pi pi-bookmark custom-book normal disabled"></i>
            }
          </span>
        }

        <sh-icon id="header-widget-icon-10" button icon='refresh' size="s" (click)="refresh()"
        [disabled]="!hasSelection"></sh-icon>
      </div>

      @if (!restrictedView && !isSiteSelection && !isLoading && deviceInformation) {
        <sh-popover id="header-widget-popover-detailed-system-informati" #systemmenu icon="laboratory-system"
          [attr.label]="'headerWidget.popover.title' | transloco" passive sticky position="left-up" target="systeminformation"
          overlay-target-distance="1" viewport-padding="0.5" style="width:350px; z-index: 500"
          [visible]="systemsOpen" (overlay-closed)="systemClosed()">
          <div style="display: flex; flex-direction: column;">
            <div #toprow style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 16px;">
              <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 auto;">
                <sh-text id="header-widget-text-12" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'headerWidget.popover.serialNumber' | transloco }}</sh-text>
                <sh-text id="header-widget-text-13" [ngClass]="'overflow'">{{deviceInformation.serial_number}}</sh-text>
              </div>
              <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 auto">
                <sh-text id="header-widget-text-14" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'headerWidget.popover.configuration' | transloco }}</sh-text>
                <sh-text id="header-widget-text-15" [ngClass]="'overflow'">{{deviceInformation.system_config}}</sh-text>
              </div>
              @if (deviceInformation?.connected_modules?.length > 0) {
                <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 auto"
                  >
                  <sh-text id="header-widget-text-16" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'headerWidget.popover.connectedModules' | transloco }}</sh-text>
                  <div
                    style="display: flex; flex-wrap: wrap; gap: 4px; align-items: center; padding-top: 4px;">
                    @for (module of deviceInformation.connected_modules; track module) {
                      <div class="custom-tag"
                        (click)="openWithParams({ material: module.material_number, serial: module.serial_number })">
                        {{module.serial_number}}
                        <sh-icon id="header-widget-icon-open-link" icon="open-link" size="xs"></sh-icon>
                      </div>
                    }
                  </div>
                </div>
              }
              @if(!businessPartnerMode) {
              <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 100%;">
                <sh-text id="header-widget-text-18" [ngClass]="'overflow'" size="body-2" color='secondary'>FLOC</sh-text>
                <sh-text id="header-widget-text-19" [ngClass]="'overflow'">{{deviceInformation.functional_location_id}}</sh-text>
              </div>
              }
              <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 100%;">
                <sh-text id="header-widget-text-18" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'headerWidget.popover.type' | transloco }}</sh-text>
                <sh-text id="header-widget-text-19" [ngClass]="'overflow'">{{deviceInformation.instrument_type}}</sh-text>
              </div>
              <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 auto;">
                <sh-text id="header-widget-text-20" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'headerWidget.popover.srsConnected' | transloco }}</sh-text>
                <sh-text id="header-widget-text-21" [ngClass]="'overflow'">{{deviceInformation.srs_connected}}</sh-text>
              </div>
              <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 auto">
                <sh-text id="header-widget-text-22" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'headerWidget.popover.softwareVersion' | transloco }}</sh-text>
                <sh-text id="header-widget-text-23" [ngClass]="'overflow'">{{deviceInformation.sw_version_srs}}</sh-text>
              </div>
              <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 100%">
                <sh-text id="header-widget-text-24" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'headerWidget.popover.installDate' | transloco }}</sh-text>
                <sh-text id="header-widget-text-25" [ngClass]="'overflow'">{{deviceInformation.install_date}}</sh-text>
              </div>
              <div style="width: calc(50% - 8px); display: flex; flex-direction: column; flex: 1 1 auto">
                <sh-text id="header-widget-text-26" [ngClass]="'overflow'" size="body-2" color='secondary'>{{ 'headerWidget.popover.status' | transloco }}</sh-text>
                <sh-text id="header-widget-text-27" [ngClass]="'overflow'">{{deviceInformation.instrument_status}}</sh-text>
              </div>
            </div>
          </div>
        </sh-popover>
      }


    </div>

  </sh-box-section>
  <!-- <sh-box-footer id="header-widget-box-footer-28" *ngIf="isSystemLoading === 'false' && deviceInformation" slot="footer" padding-top="0"
  padding-bottom="1rem">
  <sh-button id="header-widget-button-details" [icon]="checkWidgetIcon()" icon-position="right" icon-size="s" label="Details" layout="compact"
  color="secondary" size="s" (click)="onMaximize(null)"></sh-button>
</sh-box-footer> -->

</sh-box>